import "/app/node_modules/core-js/modules/es.array.iterator.js";
import "/app/node_modules/core-js/modules/es.promise.js";
import "/app/node_modules/core-js/modules/es.object.assign.js";
import "/app/node_modules/core-js/modules/es.promise.finally.js";
import VueKonva from "vue-konva";
import * as Sentry from "@sentry/vue";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import config from "../package.json";
import scrollDirective from "@/directives/scroll";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import updater from "@/lib/websocket/updater";
import "reset-css";
import "./assets/styles/index.css";
dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(utc);
var app = createApp(App);
app.directive("scroll", scrollDirective);
app.use(VueKonva);
app.use(router);
app.use(store);
updater.start();
console.log("APP version: ".concat(config.version));
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    app: app,
    dsn: process.env.VUE_APP_SENTRY_URL,
    integrations: [new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    })],
    tracesSampleRate: 1.0,
    tracingOptions: {
      trackComponents: true
    },
    ignoreErrors: ["Request failed with status code 401", 'Redirected when going from "/login" to "/dashboard" via a navigation guard']
  });
}

// app.config.performance = true;
// app.config.devtools = true;

app.mount("#app");